import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'titleCase',
  pure: true, // mejora performance porque no recalcula innecesariamente
})
export class TitleCasePipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    if (!value) return '';

    return value
      .toLowerCase()
      .split(' ')
      .filter((word) => word.trim() !== '')
      .map((word) => this.capitalizeWord(word))
      .join(' ');
  }

  private capitalizeWord(word: string): string {
    // Manejo de guiones (Ana-Maria)
    if (word.includes('-')) {
      return word
        .split('-')
        .map((segment) => this.capitalizeSegment(segment))
        .join('-');
    }

    // Manejo de apóstrofes (O'Connor)
    if (word.includes("'")) {
      return word
        .split("'")
        .map((segment) => this.capitalizeSegment(segment))
        .join("'");
    }

    return this.capitalizeSegment(word);
  }

  private capitalizeSegment(segment: string): string {
    if (!segment) return '';
    return segment.charAt(0).toUpperCase() + segment.slice(1);
  }
}
